import React, { useMemo, useState, useEffect } from 'react';
import { useMapEvents } from 'react-leaflet';
import { useAnalysis } from '../../contexts/AnalysisContext';

const MapEventHandler = ({ bounds, selectedIndex }) => {
  const [tooltip, setTooltip] = useState({ show: false, position: [0, 0], content: '' });
  const { allMSAVIvalidJsonArrays, allNDREvalidJsonArrays, allNDVIvalidJsonArrays, allNDMIvalidJsonArrays } = useAnalysis();
  const [selectedDate, setSelectedDate] = useState(null);
  const [dateArrayMapping, setDateArrayMapping] = useState([]);

  // Function to retrieve stored dates
  useEffect(() => {
    const storedDates = JSON.parse(localStorage.getItem("extractedDates")) || [];
    if (storedDates.length > 0) {
      setDateArrayMapping(storedDates);
      const storedSelectedDate = JSON.parse(localStorage.getItem("SelectedDate"));
      if (storedSelectedDate && storedDates.includes(storedSelectedDate)) {
        setSelectedDate(storedSelectedDate);
      } else {
        setSelectedDate(storedDates[0]); // Default to the first date
      }
    }
  }, [dateArrayMapping]);

  // Get the index of the selected date from local storage
  const selectedDateIndex = dateArrayMapping.indexOf(selectedDate);
 

  const getIndexValue = (x, y) => {
    const roundTo6Decimals = (value) => parseFloat(value?.toFixed(6));
    const tolerance = 1e-4;
    const isClose = (a, b) => Math.abs(a - b) < tolerance;
    let value;

    if (selectedDateIndex === -1) return "Date not found";

    switch (selectedIndex) {
      case 'MSAVI':
        value = allMSAVIvalidJsonArrays[selectedDateIndex]?.find(item => isClose(item.x, x) && isClose(item.y, y))?.MSAVI;
        break;
      case 'NDRE':
        value = allNDREvalidJsonArrays[selectedDateIndex]?.find(item => isClose(item.x, x) && isClose(item.y, y))?.NDRE;
        break;
      case 'NDVI':
        value = allNDVIvalidJsonArrays[selectedDateIndex]?.find(item => isClose(item.x, x) && isClose(item.y, y))?.NDVI;
        break;
      case 'NDMI':
        value = allNDMIvalidJsonArrays[selectedDateIndex]?.find(item => isClose(item.x, x) && isClose(item.y, y))?.NDMI;
        break;
      default:
        value = null;
    }
    return value !== undefined ? roundTo6Decimals(value) : "No match found";
  };

  const mapEvents = useMemo(() => ({
    // Title mapping
    mousemove(e) {
      const { latlng } = e;
      let title;
      switch (selectedIndex.toLowerCase()) {
        case "ndvi":
          title = "Crop Health";
          break;
        case "ndre":
          title = "Fertilizer Content";
          break;
        case "ndmi":
          title = "Moisture Content";
          break;
        case "msavi":
          title = "Gernmination & Initial Growth";
          break;
        case "ncc":
          title = "Natural Image";
          break;
        default:
          title = `${selectedIndex} Levels`;
      }

      if (bounds.contains(latlng)) {
        const indexValue = getIndexValue(latlng.lat, latlng.lng);
        setTooltip({
          show: true,
          position: [latlng.lat, latlng.lng],
          content: `${title}  ${indexValue}`
        });
      } else {
        setTooltip({ show: false, position: [0, 0], content: '' });
      }
    },
    mouseout() {
      setTooltip({ show: false, position: [0, 0], content: '' });
    }
  }), [bounds, selectedIndex, selectedDate, allMSAVIvalidJsonArrays, allNDREvalidJsonArrays, allNDVIvalidJsonArrays, allNDMIvalidJsonArrays]);

  useMapEvents(mapEvents);

  return (
    <div>
      {tooltip.show && (
        <div className="toast toast-top toast-center" style={{ marginTop: "5px" }}>
          <div className="bg-[#dbeafe] p-2 rounded-md flex flex-col gap-2 items-center justify-end">
            <span className="text-black font-semibold text-base">{tooltip.content}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default MapEventHandler;
